import { State } from 'mk2/apps/home/containers/Home/Home.reducers';
import { LoadingState } from 'mk2/reducers/loadingState';

export const initialState: State = {
    homePostIds: [],
    forumPostsIds: [],
    contestPostsIds: [],
    contestTopicId: null,
    wikiExperiencesIds: [],
    homeCounsellingIds: [],
    homeStrollerIds: [],
    photoblogPostsIds: [],
    loadingState: LoadingState.INIT,
    errorMessage: null,
    pageLoadingState: LoadingState.INIT,
    pageErrorMessage: null,
    nextPage: 0,
    lastVisitCountFriends: '',
    bazaarCounts: {
        prams: 0,
        toys: 0,
        footwear: 0,
        others: 0,
    },
};
